import { useTranslation, Trans } from 'react-i18next';
import { uniqBy } from 'es-toolkit';

import type { ErrorType } from './types';

import getRandomId from '/shared/functions/getRandomId';
import StyledErrorsList from '/shared/styled/StyledErrorsList';

import StyledHeading from '/shared/styled/components/StyledHeading';

function getKey(error: ErrorType) {
  if (error.code) {
    if (error.element) {
      return error.code + error.element;
    }
    return error.code;
  }
  if (error?.created && error?.message) {
    return `${error.created.getTime()}-${error.message.replace(/ +/gim, '-')}`;
  }
  return getRandomId();
}

function getUnique(errors: ErrorType[]) {
  return uniqBy(errors, ({ code, element }) => {
    if (element) {
      return code + element;
    }
    return code;
  });
}

function ErrorsList({ errors = [], isDebug = false }: { errors?: ErrorType[]; isDebug?: boolean }) {
  const { t } = useTranslation();
  if (!errors || errors.length <= 0) {
    return null;
  }
  return (
    <StyledErrorsList>
      <div>
        <StyledHeading as="h3" $type="h3">
          {/* @i18n: There's a problem */}
          <Trans i18nKey="shared:ErrorsList.title" />
        </StyledHeading>
        <ul>
          {getUnique(errors).map((error) => (
            <li key={getKey(error)}>
              <span>
                {isDebug && (
                  <strong>
                    {error.context}/{error.code}
                  </strong>
                )}
                {error?.isTranslated ? (
                  <>{error?.message}</>
                ) : (
                  <>{t(`shared:errors.${error.code ?? 'ERRUNKNOWNERROR'}`, error?.message, error.tokens || {})}</>
                )}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </StyledErrorsList>
  );
}

export default ErrorsList;
